import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import GeneralEntryLogFigma from '../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../Elements/CommentsEntryLogDescription';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import JsxHelper from '../Helpers/JsxHelper';
import LogComponent from '../Elements/LogComponent';
import AuthService from '../Services/authService';
import LookupText from '../Elements/LookupText';
import FigmaBadge from '../Elements/FigmaBadge';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import urlHelper from '../Helpers/urlHelper';

export default class LeadItem {
  constructor(item) {
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();
    if (item === undefined) {
      this.LeadId = '';
      this.Name = '';
      this.Description = '';
      this.ContactId = '';
      this.ContactName = '';
      this.FirstName = '';
      this.LastName = '';
      this.ClientId = '';
      this.ClientName = '';
      this.CompanyName = '';
      this.JobTitle = '';
      this.StatusCode = '';
      this.BusinessPhone = '';
      this.MobilePhone = '';
      this.HomePhone = '';
      this.OtherPhone = '';
      this.Fax = '';
      this.Email = '';
      this.WebSiteUrl = '';
      this.AddressId = '';
      this.IndustryCode = '';
      this.SourceCode = '';
      this.SourceName = '';
      this.ReferredBy = '';
      this.RefferredByNavigation = '';
      this.AllowBulkEmail = '';
      this.AllowEmail = '';
      this.AllowFax = '';
      this.AllowPhone = '';
      this.AllowPostalMail = '';
      this.AllowSendMedia = '';
      this.PrefContactMethodCode = '';
      this.Utcoffset = '';
      this.AssignedTo = loggedInUser.userId;
      this.AssignedToUserName = '';
      this.AssignedOn = '';
      this.OfficeId = loggedInUser.officeId;
      this.LeadImportId = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.IsActive = true;
      this.TimeZoneOffset = '';
      this.Salutation = '';
      this.CallbackDate = dateTimeHelper.addDaysToDate(new Date(), 3);
      this.Birthday = '';
      this.IsMspartner = '';
      this.MSPartner = '';
      this.MspartnerCode = '';
      this.AddressStreet = '';
      this.AddressCity = '';
      this.AddressState = '';
      this.AddressPostalCode = '';
      this.AddressCountry = '';
      this.AddressCountryId = '';
      this.AddressName = '';
      this.OfficeName = '';
      this.Industry = '';
      this.VATNumber = '';
      this.Status = '';
      this.TimeZoneOffsetText = '';
      this.OpportunityId = '';
      this.OpportunityName = '';
      this.ShowOpportunity = false;
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.LeadId = item.leadId;
    this.Name = item.name;
    this.Description = item.description;
    this.ContactId = item.contactId;
    this.ContactName = item.contactName;
    this.FirstName = item.firstName;
    this.LastName = item.lastName;
    this.ClientId = item.clientId;
    this.ClientName = item.clientName;
    this.CompanyName = item.companyName;
    this.JobTitle = item.jobTitle;
    this.StatusCode = item.statusCode;
    this.BusinessPhone = item.businessPhone;
    this.MobilePhone = item.mobilePhone;
    this.HomePhone = item.homePhone;
    this.OtherPhone = item.otherPhone;
    this.Fax = item.fax;
    this.Email = item.email;
    this.WebSiteUrl = item.webSiteUrl;
    this.AddressId = item.addressId;
    this.IndustryCode = item.industryCode;
    this.SourceCode = item.sourceCode;
    this.SourceName = item.sourceName;
    this.ReferredBy = item.referredBy;
    this.RefferredByNavigation = item.refferredByNavigation;
    this.AllowBulkEmail = item.allowBulkEmail;
    this.AllowEmail = item.allowEmail;
    this.AllowFax = item.allowFax;
    this.AllowPhone = item.allowPhone;
    this.AllowPostalMail = item.allowPostalMail;
    this.AllowSendMedia = item.allowSendMedia;
    this.PrefContactMethodCode = item.prefContactMethodCode;
    this.Utcoffset = item.Utcoffset;
    this.AssignedToUserName = item.assignedToUserName;
    this.AssignedTo = item.assignedTo;
    this.AssignedOn = item.assignedOn;
    this.OfficeId = item.officeId;
    this.LeadImportId = item.leadImportId;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.IsActive = item.isActive;
    this.TimeZoneOffset = item.timeZoneOffset;
    this.Salutation = item.salutation;
    this.CallbackDate = item.callbackDate;
    this.Birthday = item.birthday;
    this.IsMspartner = item.isMspartner;
    this.MSPartner = item.msPartner;
    this.MspartnerCode = item.mspartnerCode;
    this.AddressStreet = item.addressStreet;
    this.AddressCity = item.addressCity;
    this.AddressState = item.addressState;
    this.AddressPostalCode = item.addressPostalCode;
    this.AddressCountry = item.addressCountry;
    this.AddressCountryId = item.addressCountryId;
    this.AddressName = item.addressName;
    this.OfficeName = item.officeName;
    this.Industry = item.industry;
    this.VATNumber = item.vatNumber;
    this.Status = item.status;
    this.TimeZoneOffsetText = item.timeZoneOffsetText;
    this.OpportunityId = item.opportunityId;
    this.OpportunityName = item.opportunityName;
    this.ShowOpportunity = item.showOpportunity;
  }

  static NameOfTheIdField() {
    return 'LeadId';
  }
  static nameOfTheItemDetailList() {
    return 'Lead';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOn', 'ModifiedOn', 'Birthday', 'CallbackDate', 'AssignedOn'];

  static BoolFields = [
    'AllowBulkEmail',
    'AllowEmail',
    'AllowFax',
    'AllowPhone',
    'AllowPostalMail',
    'AllowSendMedia',
    'IsActive',
    'IsMspartner',
  ];

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static getAttachmentContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={8}
        entityId={item.LeadId}
      />
    );
  }

  static getCommentsContent(item) {
    return (
      <GeneralEntryLogFigma
        description={CommentsEntryLogDescription}
        context={{ entityTypeId: 8, entityId: item.LeadId }}
      />
    );
  }

  static getGeneralEditContent(item) {
    return (
      <div
        className='link'
        onClick={() => LeadItem.editGeneralFunction(item.OfficeId, item)}
      >
        Edit General
      </div>
    );
  }
  static getCompanyEditContent(item) {
    return (
      <div
        className='link'
        onClick={() => LeadItem.editGeneralFunction(item.OfficeId, item)}
      >
        Edit Company Information
      </div>
    );
  }
  static getSourceEditContent(item) {
    return (
      <div
        className='link'
        onClick={() => LeadItem.editGeneralFunction(item.OfficeId, item)}
      >
        Edit Source
      </div>
    );
  }
  static getContactEditContent(item) {
    return (
      <div
        className='link'
        onClick={() => LeadItem.editGeneralFunction(item.OfficeId, item)}
      >
        Edit Contact Information
      </div>
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'CompanyName', label: 'Company Name*', className: 'text-left' },
        { name: 'FirstName', label: 'First Name*', className: 'text-left' },
        { name: 'CallbackDate', label: 'Callback Date*' },
        { name: 'JobTitle', label: 'Job Title', className: 'text-left' },
        { name: 'LastName', label: 'Last Name*', className: 'text-left' },
        { name: 'Status', label: 'Status', className: 'text-left' },
        {
          name: LeadItem.GetOpportunityCellContent,
          label: 'Opportunity',
          className: 'text-left',
          // condition: { field: 'ShowOpportunity', value: true },
        },
        { name: '-', label: '' },
        { name: 'Description', label: 'Description', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'CompanyInformation',
      tabLabel: 'Company Information',
      icon: 'fa-solid fa-building',
      data: [
        { name: 'Industry', label: 'Industry*', className: 'text-left' },
        { name: 'IsMspartner', label: 'MS Partner', className: 'text-left' },
        { name: 'MSPartner', label: 'MS Partner', className: 'text-left' },
        { name: '-message-', label: 'Address', className: 'text-left' },
        { name: 'AddressName', label: 'Address Name', className: 'text-left' },
        { name: 'AddressStreet', label: 'Street', className: 'text-left' },
        { name: 'AddressCity', label: 'City', className: 'text-left' },
        { name: 'AddressPostalCode', label: 'Postal Code', className: 'text-left' },
        { name: 'AddressState', label: 'State/Province', className: 'text-left' },
        { name: 'AddressCountry', label: 'Country', className: 'text-left' },
      ],
    },
    {
      tabName: 'ContactInformation',
      tabLabel: 'Contact Information',
      icon: '	fa-solid fa-address-book',
      rolekey: 'home_offices_corp',
      data: [
        { name: 'BusinessPhone', label: 'Business Phone', className: 'text-left' },
        { name: 'Email', label: 'Email', className: 'text-left' },
        { name: 'VATNumber', label: 'Tax Number', className: 'text-left' },
        { name: 'MobilePhone', label: 'Mobile Phone', className: 'text-left' },
        { name: 'WebSiteUrl', label: 'Web Url', className: 'text-left' },
        { name: '-', label: '' },
        { name: '-message-', label: 'Contact Consent', className: 'text-left' },
        { name: 'AllowBulkEmail', label: 'Allow Bulk Email?', className: 'text-left' },
        { name: 'AllowEmail', label: 'Allow Email?', className: 'text-left' },
        { name: 'AllowPhone', label: 'Allow Phone?', className: 'text-left' },
        { name: 'AllowSendMedia', label: 'Allow Social Media?', className: 'text-left' },
        { name: 'AllowPostalMail', label: 'Allow Post Mail?', className: 'text-left' },
        { name: (item) => JsxHelper.YesNo(item.IsActive), label: 'Is Active?', className: 'text-left' },
      ],
    },
    {
      tabName: 'Source',
      tabLabel: 'Source',
      icon: 'fa-solid fa-arrow-up',
      rolekey: 'home_offices_emp',
      data: [
        {
          name: (item) => (
            <LookupText
              lookupId={7}
              value={item.SourceCode}
            />
          ),
          label: 'Source*',
          className: 'text-left',
        },
        { name: 'SourceName', label: 'Source Name', className: 'text-left' },
        { name: 'RefferredByNavigation', label: 'Referred By', className: 'text-left' },
        { name: 'AssignedToUserName', label: 'Assigned To', className: 'text-left' },
        { name: 'AssignedOn', label: 'Assigned On' },
        { name: 'TimeZoneOffsetText', label: 'Time Zone' },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comments',
      data: [
        { name: LeadItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-message-', label: 'The comments above are related to the primary user.' },
      ],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [{ name: LeadItem.getAttachmentContent, label: 'Attachments', width: TabListTableCellWidthEnum.TwoLines }],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: LeadItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static GetOpportunityCellContent(item) {
    if (!item.OpportunityId) {
      return '';
    }

    return urlHelper.getIconLinkComponentFigma(
      `${item.OpportunityName} (${item.OpportunityId})`,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_opportunities/search',
      `OpportunityName=${item.OpportunityId}`,
      'Open opportunity on a new tab'
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: 'ID', orderById: 'LeadId', data: 'LeadId', type: FieldTypesEnum.DataFieldWithDetails, minWidth: 70 },
      { label: 'Company Name', orderById: 'CompanyName', data: 'CompanyName', minWidth: 50 },
      { label: 'Client Name', orderById: 'ClientName', data: 'ClientName', minWidth: 50 },
      { label: 'Is Active?', orderById: 'IsActive', data: LeadItem.getIsActiveCellContent, minWidth: 50 },
      { label: 'Office', orderById: 'OfficeId', data: 'OfficeName', minWidth: 50 },
      { label: 'Callback Date', orderById: 'CallbackDate', data: 'CallbackDate', minWidth: 50 },
      { label: 'Assigned To', orderById: 'AssignedTo', data: 'AssignedToUserName', minWidth: 50 },
      { label: 'Created On', orderById: 'CreatedOn', data: 'CreatedOn', minWidth: 50 },
      {
        label: 'Converted',
        orderById: 'Converted',
        data: (item) => JsxHelper.YesNo(item.StatusCode === 5),
        minWidth: 50,
        className: 'text-left',
      },
      { label: ' ', orderById: '', data: LeadItem.getActionsContent, type: FieldTypesEnum.ActionButton, minWidth: 50 },
      // {label: "Project Type", orderById: "Name", data:"Name", type: FieldTypesEnum.DataFieldWith, minWidth:50},
      // {label: "Status", orderById: "StatusCode", data:"Status",minWidth:50,className:"text-center"},
      // {label: "Modified On", orderById: "ModifiedOn", data:"ModifiedOn",minWidth:50,className:"text-center"},
      // {label: "Edit", orderById: "", data: LeadItem.editFunction, type: FieldTypesEnum.FunctionField},
    ];
  }

  static getIsActiveCellContent(item) {
    return (
      <div
        className='pointer'
        onClick={() => LeadItem.lockFunction(item.LeadId, item)}
      >
        <FigmaBadge Active={item.IsActive} />
        {/* {JsxHelper.YesNo(item.IsActive)} */}
      </div>
    );
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='Lead'
        entityId={item.LeadId}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            disabled: item.StatusCode === 5,
            onClick: () => LeadItem.editFunction(item.LeadId, item),
          },
          {
            iconName: item.IsActive ? 'fa-solid fa-lock-open' : 'fa-solid fa-lock',
            text: item.IsActive ? 'Close Lead' : 'Reopen Lead',
            disabled: item.StatusCode === 5,
            onClick: () => LeadItem.lockFunction(item.LeadId, item),
          },
          {
            iconName: 'fa-solid fa-turn-up',
            disabled: item.StatusCode === 5,
            text: item.StatusCode === 5 ? 'Lead Already Converted' : 'Convert Lead',
            onClick: () => LeadItem.convertFunction(item.LeadId, item),
            roleKey: 'sales_leads',
          },
        ]}
      />
    );
  }

  static generateDateFieldContent(item) {
    return dateTimeHelper.isIndefinite(item.EndDate) ? (
      <span>{dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.StartDate)} - &#8734;</span>
    ) : (
      <span className='densefont-1'>{`${dateTimeHelper.toYYYYsMMsDDWithIndefinite(
        item.StartDate
      )} - ${dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.EndDate)}`}</span>
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };
  static lockFunction = (id, item, itemList) => {
    alert('Empty function');
  };
  static unlockFunction = (id, item, itemList) => {
    alert('Empty function');
  };
  static convertFunction = (id, item, itemList) => {
    alert('Convert function');
  };
}
